module.exports = __webpack_public_path__ + "media/images/result_sets/circles/7n6r5n1n-37d380d6ab22c94dad867b4c2502831a.svg";